<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!specialtiesId">Adding Specialties</span>
                <span *ngIf="specialtiesId">Update Specialties</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="specialtiesForm" (submit)="createTreatment()">

                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-4 col-lg-4 right-border">
                                <div class="form-group">
                                    <label class="form-label">Name *</label>
                                    <input type="text" placeholder="Name" formControlName="name" class="form-control" />
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Name is required</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-lg-4">
                                <label class="form-label">Show in Glamyo Health</label>
                                <mat-select placeholder="Show in Glamyo Health" formControlName="show_in_glamyo_health">
                                    <mat-option [value]="1">Yes</mat-option>
                                    <mat-option [value]="0">No</mat-option>
                                </mat-select>
                            </div>

                            <div class="col-md-4 col-lg-4">
                                <label class="form-label">Show in Glamyo Dental</label>
                                <mat-select placeholder="Show in Glamyo Dental" formControlName="show_in_glamyo_dental">
                                    <mat-option [value]="1">Yes</mat-option>
                                    <mat-option [value]="0">No</mat-option>
                                </mat-select>
                            </div>

                        </div>
                        <div class="row">

                            <div class="col-md-4 col-lg-4 right-border">
                                <div class="form-group">
                                    <label class="form-label">Online Consultation</label>
                                    <input type="number" placeholder="Online Consultation"
                                        formControlName="online_consultation" class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-4 col-lg-4 right-border">
                                <div class="form-group">
                                    <label class="form-label" *ngIf="!specialtiesId">Image*</label>
                                    <label class="form-label" *ngIf="specialtiesId">Image</label>
                                    <input type="file" (change)="selectPic($event)" class="form-control" />

                                    <div *ngIf="submitted && f.image_icon.errors" class="invalid-feedback">
                                        <div *ngIf="f.image_icon.errors.required">Image is required</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-lg-4">
                                <label class="form-label">Status *</label>
                                <mat-select placeholder="Status" formControlName="status">
                                    <mat-option [value]="1">Active</mat-option>
                                    <mat-option [value]="0">In-Active</mat-option>
                                </mat-select>
                                <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                    <div *ngIf="f.status.errors.required">Status is required</div>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6 right-border">
                                <div class="form-group">
                                    <label class="form-label">Treatments</label>
                                    <textarea placeholder="Treatments" formControlName="treatment"
                                        class="form-control"></textarea>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 right-border">
                                <div class="form-group">
                                    <label class="form-label">Description</label>
                                    <textarea placeholder="Description" formControlName="description"
                                        class="form-control"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span *ngIf="!specialtiesId">Create Specialties</span>
                        <span *ngIf="specialtiesId">Update Specialties</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>